const sparkle = (x, y, r) => {
  const i = r * 0.22;
  return `M${x} ${y - r} C${x + i} ${y - i} ${x + i} ${y - i} ${x + r} ${y} C${x + i} ${y + i} ${x + i} ${y + i} ${x} ${y + r} C${x - i} ${y + i} ${x - i} ${y + i} ${x - r} ${y} C${x - i} ${y - i} ${x - i} ${y - i} ${x} ${y - r} Z`;
};

export const RooftopMark = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g fill="currentColor">
      <path d={sparkle(45, 11, 7)} />
      <path d={sparkle(55.5, 20, 4.5)} />
      <path d={sparkle(53, 4, 3.4)} />
      <rect x="40.5" y="21" width="5" height="13" />
      <rect x="21" y="43" width="7.5" height="7.5" />
      <rect x="31.5" y="43" width="7.5" height="7.5" />
      <rect x="21" y="53" width="7.5" height="7.5" />
      <rect x="31.5" y="53" width="7.5" height="7.5" />
    </g>
    <path
      d="M3 43 L30 18 L57 43"
      fill="none"
      stroke="currentColor"
      strokeWidth="7"
      strokeLinejoin="miter"
    />
  </svg>
);

export const BrandBadge = ({ size = "h-9 w-9", icon = "h-7 w-7" }) => (
  <div
    data-testid="brand-badge"
    className={`${size} rounded-md bg-gold flex items-center justify-center shrink-0`}
  >
    <RooftopMark className={`${icon} text-white`} />
  </div>
);
